import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'underscore'
import { sendTrackingData } from '@vmockinc/dashboard/services/tracking'
import InfoScreens from '../InfoScreens'
import {
  feedbackContentProfilePicture,
  feedbackMap,
} from '../Constants/DetailedFeedbackText'
import {
  profilePictureFeedbackAriaLabel,
  infoScreenConnectLabel,
} from '../Constants/AriaLabelText'
import { InfoComponent } from '../HelperComponent/FeedbackBlock'
import { northwesternCustom } from '../Constants/CommunityCustomisationText'
import { fetchCustomisation } from '../../services/helpers'
import { showEditModal, changeProfilePicInitialEditState } from '../../actions/Edit'
import { injectIntl, FormattedMessage } from 'react-intl'
import { redirectSelect } from '../../actions/AspireFeedback'
import { selectSection } from '../../actions/DetailedFeedback'
import { hashLinkScroll } from '../../services/helpers'

const colorMap = {
  green: 'color-green',
  yellow: 'color-orange',
  red: 'color-red',
  gray: 'color-gray',
}

const symbolMap = {
  green: <span className="fa fa-check" aria-hidden="true" />,
  yellow: <span className="fa fa-exclamation" aria-hidden="true" />,
  red: <span className="fa fa-times" aria-hidden="true" />,
}

const iconMap = {
  green: 'icon-good-job.svg',
  yellow: 'icon-on-track.svg',
  red: 'icon-needs-work.svg',
}

class ProfilePicture extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showInfoScreen: false,
      activeInfoScreen: '',
    }
    this.showInfoModal = this.showInfoModal.bind(this)
    this.hideInfoModal = this.hideInfoModal.bind(this)
    this.sendTrackingDataDebounceInfoModal = _.debounce(
      sendTrackingData,
      3000,
      true
    )
    this.handleTracking = this.handleTracking.bind(this)
    this.sendTrackingDataDebounce = _.debounce(sendTrackingData, 1500, true)
    this.countOfAvailableClick = 0
  }

  renderTop(sectionColor, sectionEmpty) {
    const { tabIndex, changeProfilePicInitialEditState, showEditModal, intl, isEditModal, selectSection, redirectSelect, fetchId } = this.props
    const backbtn = (
      <button className='feedback-panel-back-button' onClick={(e) => {
        e.stopPropagation()
        e.preventDefault()
        if (isEditModal) {
          showEditModal(false, '')
        }
        selectSection('Overall')
        redirectSelect(fetchId, 'detailed', 'Overall')
        hashLinkScroll()
      }}
      aria-label={intl.formatMessage({ id: "tour.button.back"})}>
        <span className='arrow arrow-right' />
      </button>
    )
    if (sectionEmpty == true) {
      return (
        <div className='feedback-panel-top-bar'>
          {backbtn}
          <div
            className='top-bar-section-name'
            role="heading"
            aria-level="3"
          >
            <FormattedMessage id="aspire.profilePicture.profilePictureLabel" defaultMessage="Profile Picture" />
          </div>
        </div>
      )
    }

    if (!_.isEmpty(sectionColor)) {
      sectionColor = sectionColor[0]['color']
      return (
        <>
          <div className='feedback-panel-top-bar'>
            {backbtn}
            <div
              className='top-bar-section-name'
              role="heading"
              aria-level="3"
            >
              <FormattedMessage id="aspire.profilePicture.profilePictureLabel" defaultMessage="Profile Picture" />
            </div>
            <div className='top-bar-divider' />
            <div 
              className={'top-bar-status text-' + sectionColor}
              tabIndex={tabIndex}
              aria-label={ profilePictureFeedbackAriaLabel(intl)[sectionColor]['title_text']}
            >
              {feedbackContentProfilePicture(intl)[sectionColor]['title_text']}
            </div>
          </div>
          <div className='feedback-panel-info-div'>
            <div className='feedback-panel-info-text'>
              {feedbackContentProfilePicture(intl)[sectionColor]['body']}
            </div>
            <div
              className='feedback-panel-know-more'
              onClick={(e) => {
                changeProfilePicInitialEditState(0)
                showEditModal(true, 'Profile Picture')
              }}
            >
              <FormattedMessage id="aspire.profilePicture.knowMore" defaultMessage="Know more" />
            </div>
          </div>
        </>
      )
    }
    return null
  }

  showInfoModal(module) {
    this.sendTrackingDataDebounceInfoModal(
      'event',
      'aspire_info_screen_open',
      'click',
      module
    )
    this.setState({ showInfoScreen: true, activeInfoScreen: module })
  }

  hideInfoModal() {
    sendTrackingData(
      'event',
      'aspire_info_screen_close',
      'click',
      this.state.activeInfoScreen
    )
    this.setState({ showInfoScreen: false, activeInfoScreen: '' })
  }

  renderFeedback(parameter, title, feedback) {
    const { tabIndex, isUKEnable, intl } = this.props
    const paramMessages = {
      face_frame_ratio: {
        id: "aspire.params.face_frame_ratio",
        defaultMessage: "Face/Frame Ratio"
      },
      face_body_ratio: {
        id: "aspire.params.face_body_ratio",
        defaultMessage: "Face/Body Ratio"
      },
      background: {
        id: "aspire.params.background",
        defaultMessage: "Background Illumination"
      },
      foreground: {
        id: "aspire.params.foreground",
        defaultMessage: "Foreground Illumination"
      },
      pupil: {
        id: "aspire.params.pupil",
        defaultMessage: "Eye Contact"
      },
      smile: {
        id: "aspire.params.smile",
        defaultMessage: "Smile Detection"
      }
    };
    let heading = title;
    if( paramMessages[parameter]){
      heading = intl.formatMessage(paramMessages[parameter])
    }
    if (_.isUndefined(feedback['color_feedback'])) {
      let content = feedbackMap(intl, isUKEnable)[parameter]['gray']
      let eventKey = feedbackMap(intl, isUKEnable)[parameter]['key']

      let parameterFeedback = (
        <div 
          className="feedback-parameter-section"
          tabIndex={tabIndex}
          aria-label={content}
        >
          <div className='feedback-parameter-section-header'>
            <div className='feedback-parameter-status-icon'>
            </div>
            <div className="feedback-parameter-section-heading">
              {heading}
            </div> 
          </div>
        </div>
      )

      return [
        parameterFeedback,
        'not_detected',
      ]
    } else {
      let content = feedbackMap(intl, isUKEnable)[parameter][
        feedback['color_feedback']
      ]
      let eventKey = feedbackMap(intl, isUKEnable)[parameter]['key']

      let parameterFeedback = (
        <div 
          className="feedback-parameter-section"
          tabIndex={tabIndex}
          aria-label={content}
        >
          <div className='feedback-parameter-section-header'>
            <div className='feedback-parameter-status-icon'>
              <img
                alt=""
                src={`${process.env.APP_BASE_URL}dist/images/${iconMap[feedback['color_feedback']]}`}
                className="feedback-parameter-icon"
              />
            </div>
            <div className="feedback-parameter-section-heading">
              {heading}
            </div> 
          </div>
          <div className='feedback-parameter-section-detail'>
            {content}
          </div>
        </div>
      )

      return [
        parameterFeedback,
        'detected',
      ]
    }
  }

  handleTracking(module) {
    let countOfAvailableClick = this.countOfAvailableClick

    let jsonObjectForTracking = {
      eventLabel: 'feedback_panel_nav_profile_picture_click_info',
      currentSection: 'Profile Picture',
      selectedModule: module,
      countOfAvailableClick: countOfAvailableClick,
    }
    this.sendTrackingDataDebounce(
      'event',
      'aspire_detailed_feedback_screen',
      'click',
      JSON.stringify(jsonObjectForTracking)
    )
  }

  render() {
    const {
      currentSection,
      feedback,
      sectionWiseText,
      tabIndex,
      hideSmileAndFBRatio,
      user,
      intl
    } = this.props
    const { community } = user
    let currentTab = tabIndex
    let sectionEmpty = _.isEmpty(sectionWiseText['imageUrl'])
    let output = { detected: [], not_detected: [] }
    let showNorthwesternComponent = false
    if (sectionEmpty != true) {
      let params = [
        ['face_frame_ratio', 'Face/Frame Ratio'],
        ['background', 'Background Illumination'],
        ['foreground', 'Foreground Illumination'],
        ['face_body_ratio', 'Face/Body Ratio'],
        ['pupil', 'Eye Contact'],
        ['smile', 'Smile Detection'],
      ]
      if(community === "ensign"){
        params = [
          ['face_frame_ratio', 'Face/Frame Ratio'],
          ['face_body_ratio', 'Face/Body Ratio'],
          ['pupil', 'Eye Contact'],
          ['foreground', 'Foreground Illumination'],
          ['smile', 'Smile Detection'],
        ]
      }
      if (hideSmileAndFBRatio) {
        params = [
          ['face_frame_ratio', 'Face/Frame Ratio'],
          ['background', 'Background Illumination'],
          ['foreground', 'Foreground Illumination'],
          ['pupil', 'Eye Contact'],
        ]
        if(community === "ensign"){
          params = [
            ['face_frame_ratio', 'Face/Frame Ratio'],
            ['foreground', 'Foreground Illumination'],
            ['pupil', 'Eye Contact'],
          ]
        }
        showNorthwesternComponent = true
      }

      for (let i = 0; i < params.length; i++) {
        let t = this.renderFeedback(
          params[i][0],
          params[i][1],
          feedback[params[i][0]]
        )
        if (!_.isNull(t)) {
          output[t[1]].push(t[0])
        }
      }
    }

    this.countOfAvailableClick = _.size(output['detected'])

    let infoComponent = null

    if (this.state.showInfoScreen == true) {
      infoComponent = (
        <InfoScreens
          tabIndex={currentTab}
          show={this.state.showInfoScreen}
          module={this.state.activeInfoScreen}
          currentSection={currentSection}
          hideModal={this.hideInfoModal}
        />
      )
    }
    $('.panel-collapse').removeAttr('aria-expanded')
    return (
      <div>
        {infoComponent}
        <div className="feedback-panel">
          {this.renderTop(feedback['section_score'], sectionEmpty)}
          {sectionEmpty ? (
            <div className="section-feedback">
              <div 
                className={`tab-content tab-content-empty`}>
                <div
                  className='section-feedback-empty'
                  id={`empty-section`}
                  aria-label={intl.formatMessage({ id: "aspire.profilePicture.emptySectionAria", defaultMessage: "Write content to unlock the feedback for this section" })}
                >
                  <div className="empty-section-top-header">
                    <div className="empty-section-top-img">
                      <img
                        alt={intl.formatMessage({ id: "aspire.profilePicture.emptySectionAlt", defaultMessage: "empty section icon" })}
                        src={`${process.env.APP_BASE_URL}dist/images/info_empty_profile_picture.svg`}
                        className="empty-section-icon"
                      />
                    </div>
                    <div className="empty-section-top-heading">
                      <FormattedMessage id="aspire.profilePicture.emptySectionHeading" defaultMessage="You have not uploaded your profile picture!" />
                    </div>
                    <div className="empty-section-top-sub-heading">
                      <FormattedMessage id="aspire.profilePicture.emptySectionSubHeading" defaultMessage="Upload your profile picture to get an instant feedback" />
                    </div>
                  </div>
                  <div className="empty-section-bottom-info">
                    <ul
                      className="empty-section-bottom-info-list-div"
                      tabIndex={0}
                    >
                      <li className="empty-section-bottom-info-list">
                        <div className="empty-section-bottom-info-bullet"></div>
                        <FormattedMessage id="aspire.profilePicture.emptySectionBullet1" defaultMessage="Add your profile picture and get noticed by recruiters at the very first glance" />
                      </li>
                      <li className="empty-section-bottom-info-list">
                        <div className="empty-section-bottom-info-bullet"></div>
                        <FormattedMessage id="aspire.profilePicture.emptySectionBullet2" defaultMessage="Increase the visibility of your LinkedIn profile and grow your LinkedIn network" />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div 
              className='feedback-summary'
              id="personal-info-panel"
            >
              {showNorthwesternComponent ? (
                <InfoComponent
                  tabIndex={currentTab}
                  icon="insight"
                  bullet={northwesternCustom(intl).bullet}
                  intl={intl}
                />
              ) : null}
               {output['detected']}
            </div>
          )}
        </div>
      </div>
    )
  }
}


function mapStateToProps(state, ownProps) {
  return {
    isUKEnable: state.aspireFeedbackData.ukEnglish,
    hideSmileAndFBRatio: fetchCustomisation(
      state.AspireCommunityCustomization.data,
      'hide_smile_&_face_to_body_feedback'
    ),
    user: state.user.data,
    isEditModal: state.editData.show_edit_modal,
  }
}

export default connect(mapStateToProps, {
  showEditModal,
  changeProfilePicInitialEditState,
  redirectSelect,
  selectSection,
})(injectIntl(ProfilePicture))
